import React from 'react'
import styled from "styled-components";
import {Table, Tag} from "antd";
import {useNavigate} from "react-router-dom";
import {VacationApprovalRow} from "../../Model/VacationModel";

const ListWrap = styled.div`
  box-sizing: border-box;
`

const STATUS_COLOR: Record<string, string> = {
    "요청중": "blue",
    "승인됨": "green",
    "반려됨": "red",
    "취소됨": "default",
}

const VacationApprovalMini: React.FC<{data: VacationApprovalRow[]}> = ({data}) => {
    const navigate = useNavigate()

    const columns = [
        {
            title: '번호',
            dataIndex: 'seq',
            key: 'seq',
            render: (t: number) => <a>{t}</a>,
        },
        {
            title: '신청자',
            dataIndex: 'employee_name',
            key: 'employee_name',
        },
        {
            title: '제목',
            dataIndex: 'request_subject',
            key: 'request_subject',
        },
        {
            title: '기간',
            key: 'period',
            render: (_: any, r: VacationApprovalRow) => r.vacation_date_start === r.vacation_date_end
                ? r.vacation_date_start
                : `${r.vacation_date_start} ~ ${r.vacation_date_end}`,
        },
        {
            title: '상태',
            dataIndex: 'approval_status',
            key: 'approval_status',
            render: (v: string) => <Tag color={STATUS_COLOR[v] || "default"}>{v}</Tag>,
        },
    ]

    return (
        <ListWrap>
            <Table
                rowKey={"seq"}
                onRow={(r) => ({
                    onClick: () => navigate(`/Vacation/Approval/${r.seq}`),
                })}
                dataSource={data}
                columns={columns}
                pagination={false}
            />
        </ListWrap>
    )
}

export default VacationApprovalMini
